var map = {
	"./banan.png": "57a5",
	"./chleb.png": "d5ea",
	"./ciastko.png": "e1e8",
	"./cukierek.png": "6bcc",
	"./donut.png": "bb29",
	"./jajka_10.png": "203e",
	"./jajka_5.png": "3ed3",
	"./lod.png": "3812",
	"./mleko.png": "c9b7",
	"./mufinka.png": "a4ca",
	"./pizza.png": "db02",
	"./pomidor.png": "eb59",
	"./rogalik.png": "af5d",
	"./ser.png": "fcc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4965";